// dependencies
import { FadeIn } from "react-slide-fade-in";

// styling
import "./Documents.css";

// documents
import DesignReview from "./resources/documents/design-review-slides.pdf";
import SignedRequirementsDocument from "./resources/documents/signed-requirements-doc.pdf";
import TechnologyFeasibilityDocument from "./resources/documents/technology-feasibility-report.pdf";
import SoftwareDesignDocument from "./resources/documents/software-design-document.pdf";
import SoftwareTestingPlan from "./resources/documents/software-testing-plan.pdf";
import UserManual from "./resources/documents/user-manual.pdf";

var documents = [
  {
    title: "Design Review Presentation",
    semester: "Fall 2022",
    description:
      "This presentation was given at the 2022 Fall Capstone conference at High Country Conference Center. It goes over our overall plans for the next semester in terms of design and architecture of our project.",
    link: "https://www.youtube.com/embed/koI2ego6T_4",
    video: true,
  },
  {
    title: "Requirements Document",
    semester: "Fall 2022",
    description:
      "This document outlines our client's problem and our proposed solution.",
    link: SignedRequirementsDocument,
    video: false,
  },
  {
    title: "Technology Feasibility Document",
    semester: "Fall 2022",
    description:
      "This document outlines the technical and non-technical requirements and our detailed research and plan to address these problems.",
    link: TechnologyFeasibilityDocument,
    video: false,
  },
  {
    title: "Design Review II Presentation",
    semester: "Spring 2023",
    description:
      "This presentation is updated to reflect implementation progress and changes to our design.",
    link: "https://www.youtube.com/embed/koI2ego6T_4",
    video: true,
  },
  {
    title: "Software Design Document",
    semester: "Spring 2023",
    description:
      "This document outlines our architecture for the project, which helped to organize our implementation.",
    link: SoftwareDesignDocument,
    video: false,
  },
  {
    title: "Software Testing Plan",
    semester: "Spring 2023",
    description:
      "This document outlines our plan for the testing phase as well as unit testing.",
    link: SoftwareTestingPlan,
    video: false,
  },
  {
    title: "User Manual",
    semester: "Spring 2023",
    description:
      "This document was given to our client to help them understand how to use our product.",
    link: UserManual,
    video: false,
  },
];

documents = documents.reverse(); // show newest to oldest

export default function Documents() {
  return (
    <div>
      <div className="banner">
        <div className="content-wrapper">
          <h1>Documents & Videos</h1>
        </div>
      </div>
      <div className="documents-container">
        {documents.map((document) => {
          return (
            <FadeIn
              from="bottom"
              positionOffset={100}
              triggeroffset={0}
              delayInMilliseconds={0}>
              <div className="document-container box">
                <h2>{document.title}</h2>
                <p>{document.description}</p>
                {document.video ? (
                  <iframe
                    src={document.link}
                    title={document.title}
                    loading="lazy"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
                ) : (
                  <iframe
                    title={document.title}
                    src={document.link}
                    loading="lazy"></iframe>
                )}
              </div>
            </FadeIn>
          );
        })}
      </div>
    </div>
  );
}
